import React from "react";
import { Flex } from "/app/src/component";
import style from "./style.css";

const TextInput = ({
  className,
  disabled,
  onChange,
  placeholder,
  maxLength,
  onKeyDown,
  autoFocus,
  value,
  autoComplete,
  name,
  ...rest
}) => {
  let formStyle = style.FormStyle;
  if (disabled) {
    formStyle = style.DisabledFormStyle;
  }

  return (
    <Flex shrink={0} column className={style.InformationFormsWrapper} {...rest}>
      <input
        className={formStyle + " " + className}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        type={rest.type ? rest.type : "text"}
        name={name}
        autoFocus={autoFocus}
        onChange={onChange}
        value={value || ""}
        autoComplete={autoComplete}
        disabled={disabled}
        maxLength={maxLength}
      />
    </Flex>
  );
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/component/Forms/TextInput/index.js